import request from '@/plugins/request';

export function fileList (data) {
    return request({
        url: '/store/files/list',
        method: 'post',
        data
    });
}

export function fileDelete(data) {
    return request({
        url: '/store/files/delete',
        method: 'post',
        data
    });
}

export function groupList (data) {
    return request({
        url: '/store/files.group/list',
        method: 'post',
        data
    });
}

export function groupAdd (data) {
    return request({
        url: '/store/files.group/add',
        method: 'post',
        data
    });
}

export function groupEdit (data) {
    return request({
        url: '/store/files.group/edit',
        method: 'post',
        data
    });
}
